import { TestpageImg } from "assets/images";
import React, { useState, useEffect, useLayoutEffect } from "react";
import { FaRegCalendarAlt, FaCheckCircle, FaTimesCircle, FaExclamationCircle } from "react-icons/fa";
import "./TestPage.scss";
import { ProgressBar } from "react-bootstrap";
import { Userimg } from "assets/icons";
import { useParams } from "react-router-dom";
import {
  generateTestResult,
  prelimsTestResult,
  userTestSeriesDetail,
  prelimsDisplayResult,
} from "services/test";
import ListCourseSkeleton from "components/skeleton/ListCourseSkeleton";
import {
  countArray,
  momentDateFormat,
  timeFormatWith12Hour2,
} from "config/utils";
import { useCourse } from "context/context";
import useButtonLoader from "hooks/useButtonLoader";
import { errorResponse, failResponse } from "config/config";
import { getSignedUrl } from "services/master";

function TestResultSummery() {
  const { testId } = useParams();
  const [loading, setLoading] = useState(true);
  const [studentData, setStudentData] = useState({});
  const [firsttopped, setfirsttopped] = useState({});
  const [testData, setTestData] = useState({});
  const [testDetails, setTestDetails] = useState({});
  
  // New States for Detailed Analysis
  const [analysisData, setAnalysisData] = useState(null);
  const [questions, setQuestions] = useState([]);

  const { course } = useCourse();

  const [submitButtonRef, setSubmitLoading] = useButtonLoader(
    `${!testData.resultPdfUrl ? "View Result" : "Download"} `
  );

  const getTestDetails = async () => {
    try {
      setLoading(true);
      const res = await userTestSeriesDetail({
        courseId: course.courseId,
        testId,
      });
      if (res.code === 200) {
        setTestDetails(res.data.testDetails || {});
        setTestData(res.data || {});
      }
    } catch (err) {
      errorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  // ----------------------- Fetching Detailed Result & Questions -------------------------//
  const getDetailedAnalysis = async () => {
    try {
      const res = await prelimsDisplayResult({
        SectionTestID: testId,
      });

      if (res.code === 200) {
        setAnalysisData(res.data);
        setQuestions(res.data.questions || []);
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  };

  useLayoutEffect(() => {
    const getTestResult = async () => {
      try {
        setLoading(true);
        const res = await prelimsTestResult({
          SectionTestID: testId,
        });

        if (res.code === 200) {
          setStudentData(res.data.student || {});
          setfirsttopped(res.data.firsttopped || {});
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setLoading(false);
      }
    };

    if (course.courseId) {
      getTestDetails();
      getTestResult();
      getDetailedAnalysis();
    }
  }, [course, testId]);

  useEffect(() => {
    const handleDisableBackButton = () => {
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => {
        window.history.go(1);
      };
    };
    handleDisableBackButton();
    return () => {
      window.onpopstate = null;
    };
  }, []);

  // Helper function to render HTML content safely
  const renderHTML = (htmlContent) => {
    if (!htmlContent) return null;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };

  return (
    <div className="tesResult_summery testPage spacing">
      <div className="container">
        {loading && <ListCourseSkeleton height="300" />}

        {!loading && (
          <div className="testPage_banner">
            <div className="image_wrap">
              <img src={TestpageImg} alt="" loading="lazy" />
            </div>
            <div className="content">
              <h4>{testDetails.TestTitle || analysisData?.testInfo?.title}</h4>
              <ul>
                <li>
                  <FaRegCalendarAlt /> {momentDateFormat(testData.scheduleDate)}
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>

      <div className="testOverview_content spacing">
        <div className="container">
          <div className="overview">
            <h5>Overview</h5>
            <ul>
              {loading &&
                countArray(8).map((data) => (
                  <li key={data} className="p-0">
                    <ListCourseSkeleton height="90" />
                  </li>
                ))}

              {!loading && (
                <>
                  <li>
                    <h6>TOTAL MARKS</h6>
                    <p><b>{studentData?.totalMark}</b> / <sub>{studentData?.testMark} Marks</sub></p>
                  </li>
                  <li>
                    <h6>CORRECT</h6>
                    <p><b>{studentData?.correct}</b> /<sub>Questions</sub></p>
                  </li>
                  <li>
                    <h6>INCORRECT</h6>
                    <p><b>{studentData?.incorrect}</b> /<sub> Questions</sub></p>
                  </li>
                  <li>
                    <h6>UNANSWERED</h6>
                    <p><b>{studentData?.unattempt}</b> /<sub> Questions</sub></p>
                  </li>
                  <li>
                    <h6>PERCENTILE</h6>
                    <p><b>{studentData?.percentile} %</b></p>
                  </li>
                  <li>
                    <h6>ATTEMPTED STUDENTS</h6>
                    <p><b>{studentData?.attempted}</b></p>
                  </li>
                  <li>
                    <h6>SUBMIT DATE</h6>
                    <p><b>{momentDateFormat(studentData?.submittedOn)}</b></p>
                  </li>
                  <li>
                    <h6>SUBMIT TIME</h6>
                    <p><b>{timeFormatWith12Hour2(studentData?.submittedOn)}</b></p>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="compare_progress spacing">
            {loading &&
              countArray(2).map((data) => (
                <div className="student_you p-0" key={data}>
                  <ListCourseSkeleton height="300" />
                </div>
              ))}

            {!loading && (
              <>
                <div className="student_you">
                  <div className="image_wrap">
                    <img src={Userimg} alt="" loading="lazy" />
                    <h5>You</h5>
                  </div>
                  <ul>
                    <li>
                      <p><span>MARKS GAINED</span> <span>{studentData?.markGained}</span></p>
                      <ProgressBar className="success" now={studentData?.markGained} />
                    </li>
                    <li>
                      <p><span>MARKS LOST</span> <span>{studentData?.markLost}</span></p>
                      <ProgressBar className="danger" now={studentData?.markLost} />
                    </li>
                    <li>
                      <p><span>TOTAL MARKS</span> <span>{studentData?.totalMark}</span></p>
                      <ProgressBar className="danger" now={studentData?.totalMark} />
                    </li>
                  </ul>
                </div>
                <div className="student_topper">
                  <div className="image_wrap">
                    <img src={Userimg} alt="" loading="lazy" />
                    <h5>Topper</h5>
                  </div>
                  <ul>
                    <li>
                      <p><span>MARKS GAINED</span> <span>{firsttopped?.markGained}</span></p>
                      <ProgressBar className="success" now={firsttopped?.markGained} />
                    </li>
                    <li>
                      <p><span>MARKS LOST</span> <span>{firsttopped?.markLost}</span></p>
                      <ProgressBar className="danger" now={firsttopped?.markLost} />
                    </li>
                    <li>
                      <p><span>TOTAL MARKS</span> <span>{firsttopped?.totalMark}</span></p>
                      <ProgressBar className="danger" now={firsttopped?.totalMark} />
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>

          {/* ------------------- Questions List Section with HTML Rendering ------------------- */}
          <div className="questions_analysis_section spacing">
            <h5 className="mb-4">Question Analysis</h5>
            {loading ? (
              countArray(3).map((i) => <ListCourseSkeleton key={i} height="150" className="mb-3" />)
            ) : (
              <div className="questions_list">
                {questions.map((item, index) => (
                  <div key={item.QuestionID} className={`question_card ${item.isCorrect ? 'correct_bg' : item.isSkipped ? 'skipped_bg' : 'wrong_bg'}`}>
                    <div className="question_header">
                      <span className="q_no">Question {index + 1}</span>
                      <span className={`status_badge ${item.isCorrect ? 'correct' : item.isSkipped ? 'skipped' : 'wrong'}`}>
                        {item.isCorrect ? <><FaCheckCircle /> Correct</> : 
                         item.isSkipped ? <><FaExclamationCircle /> Skipped</> : 
                         <><FaTimesCircle /> Incorrect</>}
                      </span>
                    </div>
                    
                    <div className="question_body">
                      {/* Question Text with HTML rendering */}
                      <div className="q_text" dangerouslySetInnerHTML={{ __html: item.question }} />
                      
                      <div className="options_grid">
                        {item.options && item.options.map((opt, idx) => {
                          const optLabel = `Option ${["I", "II", "III", "IV"][idx]}`;
                          const isUserPick = item.yourAnswer === optLabel;
                          const isCorrectAns = item.CorrectAns === optLabel;
                          
                          return (
                            <div key={idx} className={`option_item 
                              ${isCorrectAns ? 'actual_correct' : ''} 
                              ${isUserPick && !item.isCorrect ? 'user_wrong' : ''}`}
                              dangerouslySetInnerHTML={{ __html: opt }}
                            />
                          );
                        })}
                      </div>
                    </div>

                    <div className="answer_description">
                      <h6>Explanation:</h6>
                      <div dangerouslySetInnerHTML={{ __html: item.AnswerDesc }} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestResultSummery;